import React from 'react';

export const BlockPersonalFeedPreview = React.lazy(async () => {
    const { BlockPersonalFeedPreview } = await import(
        /* webpackChunkName: 'block-personal-feed-preview' */
        './BlockPersonalFeedPreview'
    );
    return { default: BlockPersonalFeedPreview };
});
